import { AgLoadingService } from '@ag/vc.ag-ui';
import { AfterViewInit, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { SessionService } from '../../../core/services/session.service';
import { PreloadAssetService } from '../../services/preload-asset.service';

@Component({
  selector: 'app-sil-loading',
  templateUrl: './sil-loading.component.html',
  styleUrls: ['./sil-loading.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SilLoadingComponent implements AfterViewInit, OnDestroy {
  type = 'Default';
  private threshold = 150;
  private timeout = 600000;
  private subscription: Subscription;
  showLoader = false;
  private defaultLoaderPath: string;
  private documentsLoaderPath: string;
  
  defaultOptions: AnimationOptions;
  documentsOptions: AnimationOptions;

  constructor(
    private readonly loadingService: AgLoadingService,
    private readonly preloadService: PreloadAssetService,
    private readonly sessionService: SessionService
  ) {
    this.subscribeToService();
    // this.JsonConfiguration();
  }

  ngAfterViewInit(): void {
    this.JsonConfiguration();
    // this.preloadService.preload(this.defaultLoaderPath);
    // this.preloadService.preload(this.documentsLoaderPath);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeToService(): void {
    let thresholdTimer: ReturnType<typeof setTimeout>;
    let timeoutTimer: ReturnType<typeof setTimeout>;

    this.subscription = this.loadingService.getMessage().subscribe(data => {
      if (data.show) {
        if (thresholdTimer) {
          return;
        }
        thresholdTimer = setTimeout(() => {
          thresholdTimer = null;
          this.setOneTimeLoader(data.template);
          this.showLoader = true;
          if (this.timeout && this.timeout > 0) {
            timeoutTimer = setTimeout(() => {
              timeoutTimer = null;
              this.showLoader = false;
              this.resetOneTimeLoader();
            }, this.timeout);
          }
        }, this.threshold);
      } else {
        if (thresholdTimer) {
          clearTimeout(thresholdTimer);
          thresholdTimer = null;
        }
        if (timeoutTimer) {
          clearTimeout(timeoutTimer);
          timeoutTimer = null;
        }
        this.showLoader = false;
        this.resetOneTimeLoader();
      }
    });
  }

  private setOneTimeLoader(template: string) {
    if (template) {
      this.type = template;
    }
  }

  private resetOneTimeLoader() {
    this.type = 'Default';
  }

  private JsonConfiguration() {
    // const folder = this.sessionService.getContextPrefix();
    this.defaultLoaderPath = `assets/lottie/lead-global-loader.json`;

    this.documentsLoaderPath = 'assets/lottie/lead-global-loader.json';

    this.defaultOptions = {
      path: this.defaultLoaderPath,
      autoplay: true,
      loop: true
    } as AnimationOptions;

    this.documentsOptions = {
      path: this.documentsLoaderPath,
      autoplay: true,
      loop: true
    } as AnimationOptions;
  }
}
